import { getMessage, shouldPreventUnsavedChanges } from './prevent_unsaved_changes'

window.addEventListener('CookiebotOnConsentReady', function () {
  const currentCookieConsent = {
    statistics: localStorage.getItem('statisticsCookieConsent'),
    marketing: localStorage.getItem('marketingCookieConsent')
  }
  const newCookieConsent = window.Cookiebot.consent
  const cookiesChanged =
    currentCookieConsent.statistics !== String(newCookieConsent.statistics) ||
    currentCookieConsent.marketing !== String(newCookieConsent.marketing)

  if (cookiesChanged && !currentCookieConsent.statistics && !currentCookieConsent.marketing) {
    updateLocalStorage(newCookieConsent)
  } else if (cookiesChanged) {
    updateLocalStorage(newCookieConsent)
    // some external scripts don't have an option to unload them dynamically
    // so we need to reload the page to stop tracking users that no longer wish to be tracked
    window.location.reload()
  }
})

function updateLocalStorage(cookieConsent) {
  localStorage.setItem('statisticsCookieConsent', cookieConsent.statistics)
  localStorage.setItem('marketingCookieConsent', cookieConsent.marketing)
}

up.on('click', '.js-change_cookies_settings_due_to_warning', function () {
  if (!shouldPreventUnsavedChanges() || (shouldPreventUnsavedChanges() && confirm(getMessage()))) {
    window.Cookiebot.show()
  }
})
